"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._fetchPages = void 0;
const api_1 = require("../../utils/api");
const base_1 = require("../../utils/base");
const _fetchPages = (basePath, token, eventId, nbPage, params) => __awaiter(void 0, void 0, void 0, function* () {
    const base = (0, base_1.getBasePath)(basePath);
    const configUrl = () => {
        if (nbPage && params)
            return `${base.EVENTS}/${eventId}/pages?limit=36&page=${nbPage}${params}`;
        else if (nbPage)
            return `${base.EVENTS}/${eventId}/pages?limit=36&page=${nbPage}`;
        return `${base.EVENTS}/${eventId}/pages?limit=36`;
    };
    const pages = yield (0, api_1.getRequest)(configUrl(), token);
    return (pages === null || pages === void 0 ? void 0 : pages.data) || pages;
});
exports._fetchPages = _fetchPages;
